// Widths of the fixed right-hand presence rail (`OnlineUsersPanel`). Shared
// with anything that has to lay out next to it (e.g. `CustomersSelectionBar`,
// which stops its right edge where the rail starts) so the two never drift
// apart into duplicated literals.
export const COLLAPSED_W = 64;
export const EXPANDED_W = 280;
